import { render, staticRenderFns } from "./PublicVacancies.vue?vue&type=template&id=956cae1c&scoped=true"
import script from "./PublicVacancies.vue?vue&type=script&lang=js"
export * from "./PublicVacancies.vue?vue&type=script&lang=js"
import style0 from "./PublicVacancies.vue?vue&type=style&index=0&id=956cae1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956cae1c",
  null
  
)

export default component.exports